import styled from 'styled-components';
import { DEVICES } from '@thinknet-gmbh/platform-common-ui';

export const DeleteContainer = styled.div<{ isIcon: boolean }>`
  display: flex;

  ${({ isIcon }) =>
    isIcon &&
    `
    & > div:last-child {
        cursor: pointer;
        margin-left: 18px;
        margin-top: 7px;
          @media ${DEVICES.sm} {
        margin-top: 8px;
}
    }
  `}

  @media ${DEVICES.sm} {
    width: 100%;
    display: flex;
    justify-content: space-between;
  .ant-row {
    display: block;
    width: 100%;
  }
}
`;

export const FormListWrapper = styled.div<{ isIcon: boolean; isSalary?: boolean }>`
  display: flex;
  flex-direction: column;
  width: 100%;

  .ant-form-item {
    min-width: 288px;
  }

  & > div:last-child {
    margin-top: ${({ isSalary }) => (isSalary ? 0 : '10px')};
    margin-right: ${({ isIcon }) => (isIcon ? '40px' : 0)};
    align-self: flex-end;

    .ant-btn {
      padding: 0;
    }
  }
  @media ${DEVICES.sm} {
    & > div:first-child {
      display: none;
    }
  }
`;

export const SkillItemContainer = styled.div`
  @media ${DEVICES.sm} {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
`;
